'use client'

import { useEffect } from 'react'
import { useUser } from '@auth0/nextjs-auth0'

const AUTH0_HOSTS = [
  'auth-develop.admission.naba.it',
  'auth.admission.naba.it',
  'dev-naba-competitions.eu.auth0.com',
  'naba-competitions.eu.auth0.com',
]

const CREATED_AT_CLAIM = 'https://admission.naba.it/created_at'
const STORAGE_KEY = 'gx.authentication.completed'
const NEW_ACCOUNT_WINDOW_MS = 60_000

type SessionUser = {
  sub?: string
  created_at?: string
  [CREATED_AT_CLAIM]?: string
}

const methodFromSub = (sub: string) =>
  sub.startsWith('google-oauth2|') ? 'google' : 'email'

const AuthenticationTracker = ({ enabled }: { enabled: boolean }) => {
  const { user } = useUser()

  useEffect(() => {
    const sessionUser = user as SessionUser | undefined
    if (!enabled || !sessionUser?.sub) return

    const fromAuth0 = AUTH0_HOSTS.some((host) =>
      document.referrer.includes(host)
    )
    if (!fromAuth0) return
    if (sessionStorage.getItem(STORAGE_KEY) === sessionUser.sub) return

    sessionStorage.setItem(STORAGE_KEY, sessionUser.sub)

    const createdAt = sessionUser.created_at || sessionUser[CREATED_AT_CLAIM]
    const createdMs = createdAt ? Date.parse(createdAt) : Number.NaN
    const isNewAccount =
      Number.isFinite(createdMs) &&
      Date.now() - createdMs < NEW_ACCOUNT_WINDOW_MS

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'gx.authentication',
      event_name: isNewAccount ? 'sign_up' : 'login',
      authentication: { method: methodFromSub(sessionUser.sub) },
    })
  }, [enabled, user])

  return null
}

export default AuthenticationTracker
